import React from 'react'
import { Radio } from 'antd'
import './index.css'
import classNames from 'classnames'

const FormRadioGroup = ({
  Form,
  label,
  name,
  onChange,
  value,
  rules = [],
  children,
  radioButtonsRowCount = 4,
  formItemStyles = {},
  disabled = false,
  ...extra
}) => {
  return (
    <Form.Item
      value={value}
      rules={rules}
      onChange={onChange}
      label={label}
      name={name}
      {...extra}
      className={
        radioButtonsRowCount === 3
          ? classNames('v2FormRadio', 'v2FormRadioInline3')
          : classNames('v2FormRadio', 'v2FormRadioInline4')
      }
    >
      <Radio.Group initialValue={value} disabled={disabled} style={formItemStyles}>
        {children}
      </Radio.Group>
    </Form.Item>
  )
}

export default FormRadioGroup
